import { api } from '../api.js';
import { t, wanneer } from '../i18n.js';

/**
 * Beheer › Gebruikers: wie via het klantportaal binnenkomt, elk bij precies één klant, met zijn rollen voor klanten. Wie dat mag, bepaalt het
 * portaal (het recht `zero` en tweestapsverificatie); uitzetten hier houdt iemand buiten ZERO, ook als het portaal
 * hem nog doorlaat, en sluit zijn open sessies. Zie docs/besluiten/klanten-via-het-portaal.md.
 */
export default function BeheerGebruikers({ gebruikers, rollen, doe }) {
  const wissel = (lijst, waarde, aan) => (aan ? [...lijst, waarde] : lijst.filter((x) => x !== waarde));
  return (
    <>
      <section className="card">
        {gebruikers.length ? (
          <table>
            <thead><tr><th>{t('Gebruiker')}</th><th>{t('Klant')}</th><th>{t('Rollen')}</th><th>{t('Laatst aangemeld')}</th><th>{t('Actief')}</th></tr></thead>
            <tbody>
              {gebruikers.map((g) => (
                <tr key={g.id}>
                  <td><b>{g.email ?? t('zonder e-mail')}</b>
                    {g.orgAdmin && <> <span className="pill">{t('beheerder in het portaal')}</span></>}</td>
                  <td>{g.tenant.name}</td>
                  <td>{rollen.map((r) => (
                    <div key={r.code}><label className="vink"><input type="checkbox" checked={g.roles.includes(r.code)}
                      onChange={(e) => doe(() => api.wijzigKlantgebruiker(g.id, { roles: wissel(g.roles, r.code, e.target.checked) }))} />
                      {t(r.label)}</label></div>))}</td>
                  <td className="muted">{g.lastSignInAt ? wanneer(g.lastSignInAt) : t('nooit')}</td>
                  <td><label className="vink"><input type="checkbox" checked={g.active} aria-label={t('Actief')}
                    onChange={(e) => doe(() => api.wijzigKlantgebruiker(g.id, { active: e.target.checked }))} /></label></td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : <p className="muted">{t('Nog niemand is via het klantportaal binnengekomen.')}</p>}
      </section>
      <p className="muted" style={{ fontSize: 13, marginTop: 10 }}>
        {t('Een gebruiker komt binnen via het klantportaal, met tweestapsverificatie, en ziet alleen zijn eigen klant. Wie dat mag, bepaalt het portaal; uitzetten hier houdt hem buiten ADTS ZERO, ook als het portaal hem nog doorlaat.')}
      </p>
    </>
  );
}
